function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 8h31v31H8V8z",
  fill: "#2600A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.05 0C10.321 0 0 10.321 0 23.05 0 35.779 10.321 46.1 23.05 46.1c12.729 0 23.05-10.321 23.05-23.05C46.1 10.321 35.779 0 23.05 0zm-6.698 34.845h-5.614V17.957h5.614v16.888zM13.545 15.65h-.036c-1.883 0-3.102-1.298-3.102-2.918 0-1.656 1.255-2.918 3.175-2.918 1.921 0 3.103 1.262 3.139 2.92 0 1.618-1.218 2.916-3.176 2.916zm23.05 19.195H30.98v-9.036c0-2.27-.813-3.818-2.845-3.818-1.55 0-2.474 1.044-2.88 2.053-.149.36-.184.865-.184 1.37v9.43h-5.613s.074-15.303 0-16.887h5.613v2.39c.746-1.15 2.08-2.788 5.059-2.788 3.693 0 6.462 2.414 6.462 7.601v9.685h.002z",
  fill: "#FCE400"
}));